module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "top center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.snackbarMessage))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Lukk")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081d5d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/App.vue
// module id = 635
// module chunks = 1